import React, { useState } from 'react';
import axios from 'axios';
import authbanner from "../../assets/globalImgs/auth-banner.png"; // Adjust the import path as necessary
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import useHandleErrors from '../../utils/user.utils';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleErrors = useHandleErrors();
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      toast.success("Please enter your email address!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      const path = "/forgotPassword";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, { OfficialEmail: email });

      if (response.status === 200) {
        setShowModal(true)
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/")

  };

  return (
    <div>
      {loading && (
        <div id="preloading">
          <span className="loader"></span>
        </div>
      )}
      <ToastContainer />
      <div className="wrapper">
        <section className="login-content">
          <div className="container">
            <div className="row align-items-center justify-content-center height-self-center">
              <div className="col-lg-8">
                <div className="card auth-card">
                  <div className="card-body p-0">
                    <div className="d-flex align-items-center auth-content">
                      <div className="col-lg-6 content-right text-center">
                        <img
                          src={authbanner}
                          className="img-fluid signin-banner"
                          alt="Signin Banner"
                        />
                      </div>
                      <div className="col-lg-6 align-self-center">
                        <div className="p-3">
                          <h3 className="mb-2">Reset Password</h3>
                          <p>
                            Enter your email address and we'll send you an email
                            with instructions to reset your password.
                          </p>
                          <form onSubmit={handleSubmit}>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="floating-label form-group">
                                  <input
                                    className="floating-input form-control"
                                    type="email"
                                    placeholder=" "
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                  />
                                  <label>Email</label>
                                </div>
                              </div>
                            </div>
                            <button type="submit" className="btn btn-primary">
                              Reset
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div className="modal-content shadow success-modal">
              <div className="modal-header py-2">
                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                  <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                </button>
              </div>
              <div className="modal-body pb-5">
                <div className="row">
                  <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                  <div className="col-12 text-center">Password reset instructions have been sent to your email!.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default ForgotPassword;

